import {firebase,storage,timestamp} from "./index"
import {collections,documents,constants} from "./firestoreNameSpaces"
import * as data from "../data";
import { generateUniqueId, uploadImage } from "../store/utility";
import axios from "axios";

//Always  use set() when merge objects
//Trim values before sending to server
 //While using Admin Panel, Fetch categories from   k5metadata and subcategories from categories from categories separate collection
//Dont give delete option to category Shop 

//***** make variantId = productId + variantId


//Categories-------------------------------
const checkCategoryExist = (categories,newcategoryname)=>{
    if (!categories) {
        return alert("categories is null");
      }
      let res = categories.filter(
        (categoryObj) => categoryObj.categoryName === newcategoryname.trim()
      ).length;
      if (res) {
        return true
       
      }else{
          return false
      }
}
const checkSubcategoryExist = (subcategories,newsubcategoryname)=>{
    let exists = subcategories.filter(sObj=>sObj.name===newsubcategoryname).length
    if(exists){
        return true
    }else{
        return false
    }
}
export const fetchCategoriesAdmin = async ()=>{
    
    let db = firebase.firestore();
    db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
    .onSnapshot(snapshot=>{
        let categories = [];
        let data = snapshot.data();
        for(let docKey in data){
            let category = data[docKey];
            let subcategory = [];
            if(category.subcategories){
                for(let skey in category.subcategories){
                    subcategory.push({name:category.subcategories[skey],id:skey})
                }
                category.subcategories = subcategory;
                subcategory = [];
            }
            categories.push(category)
            
        }
        console.log(categories)
    })
}
export const fetchCategoriesClient = async()=>{
    try{ 
        let categories = [];
        let db = firebase.firestore();
        let snapshot = await db.collection(collections.K5METADATA).doc(documents.CATEGORIES).get()
        let data = snapshot.data();
        for(let docKey in data){
            let category = data[docKey];
            let subcategory = [];
            if(category.subcategories){
                for(let skey in category.subcategories){
                    subcategory.push({name:category.subcategories[skey],id:skey})
                }
                category.subcategories = subcategory;
                subcategory = [];
            }
            categories.push(category)
            
        }
        console.log(categories)
    }catch(error){
        return alert(error)
    }
   

}
export const createCategory = async()=>{
        let categories = data.categories;
        let category = {
            categoryName:"Shop",
            subcategories:{}
        }
        //############################
        let exist = checkCategoryExist(categories,category.categoryName)
        if(exist){
            return  alert("Category Already exists, please choose different name");
        }
        try {
         
          let db = firebase.firestore();
          const batch = db.batch();
          
        

        let categoryId = db.collection(collections.CATEGORIES).doc().id; 
          category["id"] = categoryId;
        
         let c1 = db.collection(collections.CATEGORIES).doc(categoryId)
        batch.set(c1,category)
         let c2 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
         batch.set(c2,{ [categoryId]: category }, { merge: true })

        await batch.commit()

        alert("Category Added Successfully...")
            
        } catch (err) {
            return alert(err)
        }
     
} 

export const createSubcategory = async()=>{

       try{
        let newSubcategory = "Injections"
        let category = {
            categoryId:"mn8Ja1yF7AE9es2QZsrp",
            categoryName:"Shop",
            subcategories:[]
        }//from metadata
//############################################

 //Avoid Subcategory duplicates
 if (category.subcategories) {
    let exists = checkSubcategoryExist(category.subcategories,newSubcategory)
    if (exists) {
      return alert("Sub-Category already exists. Please Try some other name");
    }
  }
  
  let categoryId = category.categoryId;
  const db = firebase.firestore();
  const batch = db.batch();
  let subcategoryId = db.collection(collections.CATEGORIES).doc().id+generateUniqueId(4)
  //Adding to array in metadata
  let c1 =  db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
    batch.set(c1,
      {
        [categoryId]: {
          [constants.SUBCATEGORIES]: {
              [subcategoryId]:newSubcategory
          },
        },
      },
      { merge: true }
    );
//let categoryId = db.collection(collections.CATEGORIES).doc().id;
  // Adding to categories collection
  
  let c2 =  db.collection(collections.CATEGORIES).doc(categoryId)
  batch.set(c2,{
     [constants.SUBCATEGORIES]: {
         [subcategoryId]:newSubcategory
     }
  },{merge:true})
  
     await batch.commit();
     return alert("Subcategory Added Successfully...")
       }catch(error){
            return alert(error)
       }

}

export const renameCategory = async()=>{
    try{

        let newcategoryname = "Weight Gain";
        let categoryId = "5g2xYWXfTiQ6xMiTW6TX";
        let categories = data.categories;
        //#####################
        let exist = checkCategoryExist(categories,newcategoryname);
        if(exist){
            return alert("Please Enter a Different category Name")
        }
        let db = firebase.firestore();
        let batch = db.batch();
        let c1 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
        batch.set(c1,{[categoryId]:{categoryName:newcategoryname}},{merge:true})
        let c2 = db.collection(collections.CATEGORIES).doc(categoryId)
        batch.update(c2,{categoryName:newcategoryname})
        await batch.commit()
        return alert("Category Renamed Successfully")
        
    }catch(error){
        return alert(error)
    }
}
 

export const renameSubcategory = async()=>{
try{

    let categoryId = "5g2xYWXfTiQ6xMiTW6TX";
    let newsubcategoryname ="Diet Meals"
    let subcategory={id:"PmqrAZGoFrYXKGfzzKh2",name:"Diet"};
    let subcategoryId = subcategory.id;
    let category = {
        categoryId:"5g2xYWXfTiQ6xMiTW6TX",
        categoryName:"Weight Loss",
        subcategories:[]
    }
    //###################
    if(checkSubcategoryExist(category.subcategories,newsubcategoryname)){
        return alert("Please Enter different Subcategory")
    }
    let db = firebase.firestore();
    let batch = db.batch();
    let c1 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
    batch.set(c1,{[categoryId]:{[constants.SUBCATEGORIES]:{[subcategoryId]:newsubcategoryname}}},{merge:true})
    let c2 = db.collection(collections.CATEGORIES).doc(categoryId)
    batch.set(c2,{[constants.SUBCATEGORIES]:{[subcategoryId]:newsubcategoryname}},{merge:true})
    await batch.commit();
    return alert("Subcategory Rename Successfully")

}catch(error){

    return alert(error)
}

   
}

export const deleteSubcategory = async()=>{
    try{
        let categoryId = "5g2xYWXfTiQ6xMiTW6TX";
        let subcategory={id:"NSGIGD4Bn9ntFRNTGq4q",name:"Belly Fat"};
        let subcategoryId = subcategory.id
        //######################

        let db = firebase.firestore();
        let batch = db.batch();

        let c1 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES)
        batch.set(c1,{[categoryId]:{subcategories:{[subcategoryId]:firebase.firestore.FieldValue.delete()}}},{merge:true});
        let c2 = db.collection(collections.CATEGORIES).doc(categoryId)
        batch.set(c2,{subcategories:{[subcategoryId]:firebase.firestore.FieldValue.delete()}},{merge:true})
        await batch.commit()
        return alert("Subcategory Deleted Successfully")
    }catch(error){
        return alert(error)
    }
    
}
export const deleteCategory = async()=>{

   try{
        let categoryId = "5g2xYWXfTiQ6xMiTW6TX"

        //############################
        let db = firebase.firestore();
        let batch = db.batch();
        let c1 = db.collection(collections.K5METADATA).doc(documents.CATEGORIES);
        batch.set(c1,{[categoryId]:firebase.firestore.FieldValue.delete()},{merge:true})
        let c2 = db.collection(collections.CATEGORIES).doc(categoryId)
        batch.delete(c2)
        await batch.commit();
        return alert("Category Deleted Successfully")
   }catch(error){
       return alert(error)
   }
}

export const getId = ()=>{
    let ids= [];
    for(let i=0;i<10000;i++){
       
        let id = generateUniqueId(4);
        if(ids.includes(id)){
            console.log("Duplicate Found")
        }
        ids.push(id)
       
    }
    console.log("Completed")
    // setInterval(()=>{
    //     console.log(firebase.firestore.Timestamp.now().nanoseconds)
    // },100)
    // for(let i=0;i<10000;i++){
    //     // console.log(firebase.firestore.Timestamp.now().nanoseconds)
    //     console.log(Math.random()*1000000)
    // }
}
 
//BRANDS-----------------------------------------------------------
const  checkBrandExists = (brands,brandname)=>{
    let exists = brands.filter(bObj=>bObj.name==brandname.trim())[0];
    if(exists){
        return true
    }else{
        return false
    }
}
export const fetchBrandsAdmin = async()=>{
    try{

        let db = firebase.firestore();
        db.collection(collections.K5METADATA).doc(documents.BRANDS)
        .onSnapshot(snapshot=>{
            let brands = [];
            let data = snapshot.data();
            for(let bkey in data){
                brands.push(data[bkey])
            }
            console.log(brands)
        })

    }catch(error){
        return alert(error)
    }
}
export const fetchBrandsClient  = async()=>{
    try{

        let db = firebase.firestore();
        let snapshot = await db.collection(collections.K5METADATA).doc(documents.BRANDS).get()
        let brands = [];
        let data = snapshot.data();
        for(let bkey in data){
                brands.push(data[bkey])
            }
            console.log(brands)

    }catch(error){
        return alert(error)
    }
}
export const createBrand = async()=>{
    try{
        let brand = {name:"ON"}
        //#######################################
        if(checkBrandExists(data.brands,brand.name)){
            return alert("Please Enter different Name")
        }
        //let imgUrl = uploadImage()
        //brand.imgUrl = imgUrl
        let db = firebase.firestore();
        let id = db.collection(collections.K5METADATA).doc().id+generateUniqueId(4)
        brand.id = id;
        
        await db.collection(collections.K5METADATA).doc(documents.BRANDS).set({[id]:brand},{merge:true})

        return alert("Branded Added Successfully")
    }catch(error){
        return alert(error)
    }
}
export const renameBrand  = async()=>{
    try{
        let brands = data.brands;
        let brand = {id:"vlEsGQ2UqyWNVBocQFqm895f",name:"Optimum Nutrition"}
        let brandId = brand.id;
        let newbrandname="Optimum Nutrition";
        if(checkBrandExists(brands,newbrandname)){
            return alert("Brand Exists, Please Enter different Name")
        }
        //#######################
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.BRANDS).set({[brandId]:{name:newbrandname}})
        return alert("Brand Renamed Successfully")
    }catch(error){
        return alert(error)
    }
}
export const deleteBrand = async()=>{
    try{

        let brandId = "vlEsGQ2UqyWNVBocQFqm895f";
        //##############
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.BRANDS)
        .set({[brandId]:firebase.firestore.FieldValue.delete()},{merge:true})

        return alert("Brand Deleted Successfully")

    }catch(error){

        return alert(error)
    }
}

//Shop

export const fetchShopSubcategory = async()=>{
    try{

        let db = firebase.firestore();
        db.collection(collections.K5METADATA).doc(documents.SHOP)
        .onSnapshot(snapshot=>{
            let subcategories = []
            let data = snapshot.data();
            if(data.subcategories){
                for(let sk in data.subcategories){
                    subcategories.push({name:data.subcategories[sk],id:sk})
                }
                data.subcategories = subcategories;
            }else{
                data.subcategories = []
            }
           
            console.log([data]);

        })

    }catch(error){
        return alert(error)
    }
}
export const createShopSubcategory  = async()=>{
    try{
        let subcategories = data.shopcategories[0].subcategories;
        let newsubcategory = "Muscle Injection";
        //#####################
        if(subcategories.includes(newsubcategory.trim())){
            return alert("Please choose different subcategory")
        }
        let db = firebase.firestore();
        let subcategoryId = generateUniqueId(12)+subcategories.length+1
        await db.collection(collections.K5METADATA).doc(documents.SHOP).set({subcategories:{[subcategoryId]:newsubcategory}},{merge:true})
        return alert(newsubcategory+" Added Successfully")
    }catch(error){
        return alert(error)
    }
}

export const renameShopSubcategory = async()=>{
    try{
        let subcategories = data.shopcategories[0].subcategories;
        let subcategoryId = "bb5f3006d7";
        let newsubcategory = "Biceps Growth";
        //#################
        if(subcategories.includes(newsubcategory.trim())){
            return alert("Please choose different subcategory")
        }
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.SHOP).set({subcategories:{[subcategoryId]:newsubcategory}},{merge:true})
        return alert("Renamed Successfully")
    }catch(error){
        return alert(error)
    }
}

export const deleteShopSubcategory = async()=>{
    try{

        let subcategoryId = "sadasddd";
        //##########
        let db = firebase.firestore();
       await db.collection(collections.K5METADATA).doc(documents.SHOP).set({subcategories:{[subcategoryId]:firebase.firestore.FieldValue.delete()}},{merge:true})
    return alert("Deleted Successfully")
    }catch(error){
        return alert(error)
    }
}

//Attributes
const checkAttributeExist = (attributes,attributeName)=>{
    return attributes.filter(obj=>obj.attributeName.trim()==attributeName.trim()).length;
}
const checkAttributeValueExist = (values,attrValue)=>{
    return(values.includes(attrValue.trim()))
} 
export const fetchAttributes = async ()=>{
    try{
        let db = firebase.firestore();
        db.collection(collections.K5METADATA).doc(documents.ATTRIBUTES)
        .onSnapshot(snapshot=>{
            let attributes = [];
            let data = snapshot.data();
            for(let ak in data){
                attributes.push(data[ak])
            }
            console.log(attributes)
        })
    }catch(error){
        return alert(error)
    }
}
export const createAttribute = async()=>{

        try{
            let attributeName = "Dimesions";
            let attributes = data.attributes;
           if(checkAttributeExist(attributes,attributeName)){
               return alert("Please Enter a different Name")
           }
            //##############
            let db = firebase.firestore();
            let attrId = generateUniqueId(12);
            await db.collection(collections.K5METADATA).doc(documents.ATTRIBUTES)
            .set({[attrId]:{id:attrId,name:attributeName}},{merge:true})
            return alert(`${attributeName} Added Successfully`)

        }catch(error){
            return alert(error)
        }
    
} 
export const createAtrributeValue = async()=>{
    try{
        let attrId = "c2d1a40fe6a9";
        let attrValue = "Grey";
        let attribute = {
            id:"c2d1a40fe6a9",
            attributeName: "Color",
            values: ["Red", "Green", "Blue", "Yellow"],
        }
         //############
        if(checkAttributeValueExist(attribute.values,attrValue)){
            return alert("Please Enter Differnent Value")
        }
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.ATTRIBUTES)
        .set({[attrId]:{values:firebase.firestore.FieldValue.arrayUnion(attrValue)}},{merge:true})
        return alert(attrValue+" Added Succssfully")
       
    }catch(error){
        return alert(error)
    }
}
export const deleteAttributeValue = async()=>{
    try{
        let attrId = "c2d1a40fe6a9";
        let attrValue = "Grey";
        //###############
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.ATTRIBUTES)
        .set({[attrId]:{values:firebase.firestore.FieldValue.arrayRemove(attrValue)}},{merge:true})
        return alert(attrValue+" Deleted Successfully")
    }catch(error){
        return alert(error)
    }
}
export const renameAttribute = async()=>{
    try{
        let newattributename = "Color";
        let attributeId = "c2d1a40fe6a9";
        let attributes = data.attributes;
        //###########
        if(checkAttributeExist(attributes,newattributename)){
            return alert("Please Enter a different Name")
        }
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.ATTRIBUTES)
        .set({[attributeId]:{name:newattributename,id:attributeId}},{merge:true})
        return alert("Attribute Renamed Successfully")
    }catch(error){
        return alert(error)
    }
}
export const deletAttribute = async()=>{
    try{
        let attributeId = "9050cb863c73"
        //##############
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.ATTRIBUTES)
        .set({[attributeId]:firebase.firestore.FieldValue.delete()},{merge:true});
        return alert("Attribute Deleted Successfully")
    }catch(error){
        return alert(error)
    }
}
 
//ProductType
export const fetchProductType = async()=>{
    try{

        let db = firebase.firestore();
        let data = (await db.collection(collections.K5METADATA).doc(documents.PRODUCTTYPE).get()).data();
        let productType = [];
        for(let ptk in data){
            productType.push(data[ptk])
        }
        console.log(productType)
    }catch(error){
        return alert(error)
    }
}

//Workouts
const checkWorkoutPlanExist = (workouts,workoutPlanName)=>{
    return (workouts.filter(obj=>obj.categoryName==workoutPlanName.trim()).length)
}
const checkWorkoutExist = (workouts,newworkoutTitle)=>{
    return(workouts.filter(workout=>workout.title===newworkoutTitle.trim()).length)
}
export const fetchWorkoutPlans = async()=>{
    try{
        let workoutPlans = [];
        let db = firebase.firestore();
        let snapshot = await db.collection(collections.K5METADATA).doc(documents.WORKOUTS).get()
        let data = snapshot.data();
        for(let docKey in data){
            let category = data[docKey];
            let subcategory = [];
            if(category.workouts){
                for(let skey in category.workouts){
                    subcategory.push(category.workouts[skey])
                }
                category.workouts = subcategory;
                subcategory = [];
            }
            workoutPlans.push(category)
            
        }
        console.log(workoutPlans)
    }catch(error){
        return alert(error)
    }
}
export const fetchSingleWorkoutPlan = async()=>{
    try{
       
        let id = "BjtoKMSRvejNhwKeyCCf";
        //###########
        let db = firebase.firestore();
        let data = (await db.collection(collections.WORKOUTS).doc(id).get()).data();
        if(data){
            let workouts = [];
            for(let wk in data.workouts){
                workouts.push(data.workouts[wk])
            }
            data.workouts = workouts;
            console.log(data)
        }else{

        }
       
    }catch(error){
        return alert(error)
    }
}
export const createWorkoutPlan = async()=>{
    let workouts = data.workoutPlans;
    let workout = {categoryName:"Muscle Building",desc:"Its time to make some gains",workouts:{}}
    //############################
    let exist = checkWorkoutPlanExist(workouts,workout.categoryName)
    if(exist){
        return  alert("Workout Plan Already exists, please choose different name");
    }
    try {
     
      let db = firebase.firestore();
      const batch = db.batch();
      
    let categoryId = db.collection(collections.WORKOUTS).doc().id; 
      workout["id"] = categoryId;
    
     let c1 = db.collection(collections.WORKOUTS).doc(categoryId)
    batch.set(c1,workout)
     let c2 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS)
     batch.set(c2,{ [categoryId]: workout }, { merge: true })

    await batch.commit()

    alert("Workout Plan Added Successfully...")
        
    } catch (err) {
        return alert(err)
    }
 
}
export const createWorkout = async()=>{

    try{
        let newSubcategory = "Youtube Title"
        let url = "https://www.youtube.com/embed/rs3fBoxr0iI"
        let workoutPlan = {
            id:"BjtoKMSRvejNhwKeyCCf",
            categoryName:"Muscle Building",
            workouts:[]
        }//from metadata
//############################################

 //Avoid Subcategory duplicates
 if (workoutPlan.workouts) {
    let exists = checkWorkoutExist(workoutPlan.workouts,newSubcategory)
    if (exists) {
      return alert("Workout already exists. Please Try some other Title");
    }
  }
  
  let categoryId = workoutPlan.id;
  const db = firebase.firestore();
  const batch = db.batch();
  let subcategoryId = db.collection(collections.WORKOUTS).doc().id+generateUniqueId(4)
  //Adding to array in metadata
  let c1 =  db.collection(collections.K5METADATA).doc(documents.WORKOUTS)
    batch.set(c1,
      {
        [categoryId]: {
          [constants.WORKOUTS]: {
              [subcategoryId]:{id:subcategoryId,title:newSubcategory,url:url}
          },
        },
      },
      { merge: true }
    );
//let categoryId = db.collection(collections.CATEGORIES).doc().id;
  // Adding to categories collection
  
  let c2 =  db.collection(collections.WORKOUTS).doc(categoryId)
  batch.set(c2,{
     [constants.WORKOUTS]: {
         [subcategoryId]:{id:subcategoryId,title:newSubcategory,url:url}
     }
  },{merge:true})
  
     await batch.commit();
     return alert("Workout Added Successfully...")
       }catch(error){
            return alert(error)
       }
}
export const renameWorkoutPlan = async()=>{
    try{

        let newcategoryname = "Weight Gain";
        let categoryId = "BjtoKMSRvejNhwKeyCCf";
        let categories = data.workoutPlans;
        //#####################
        let exist = checkWorkoutPlanExist(categories,newcategoryname)
        if(exist){
            return alert("Please Enter a Different Workout Plan Name")
        }
        let db = firebase.firestore();
        let batch = db.batch();
        let c1 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS)
        batch.set(c1,{[categoryId]:{categoryName:newcategoryname}},{merge:true})
        let c2 = db.collection(collections.WORKOUTS).doc(categoryId)
        batch.update(c2,{categoryName:newcategoryname})
        await batch.commit()
        return alert("Workout Plan Renamed Successfully")
        
    }catch(error){
        return alert(error)
    }
}
export const editWorkout = async()=>{

    try{

        let subcategory={id:"yUKC1W5qBw05k8QOMXJ41186",url:"https://www.youtube.com/embed/jF0fMl84Il4",title:"Youtube Title2"}; //The edited one
        
        let category = {
            id:"BjtoKMSRvejNhwKeyCCf",
            categoryName:"Weight Loss",
            workouts:[]
        }
        let categoryId = category.id;
        let subcategoryId = subcategory.id;
        //###################
        // if(checkWorkoutExist(category.workouts,newsubcategoryname)){
        //     return alert("Please Enter different Workout Tit")
        // }
        
        let db = firebase.firestore();
        let batch = db.batch();
        let c1 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS)
        batch.set(c1,{[categoryId]:{[constants.WORKOUTS]:{[subcategoryId]:subcategory}}},{merge:true})
        let c2 = db.collection(collections.WORKOUTS).doc(categoryId)
        batch.set(c2,{[constants.WORKOUTS]:{[subcategoryId]:subcategory}},{merge:true})
        await batch.commit();
        return alert("Workout Edited Successfully")
    
    }catch(error){
    
        return alert(error)
    }
}
export const deleteWorkout = async()=>{

    try{
        let categoryId = "BjtoKMSRvejNhwKeyCCf";
        let subcategory={id:"yUKC1W5qBw05k8QOMXJ41186",name:"Belly Fat"};
        let subcategoryId = subcategory.id
        //######################

        let db = firebase.firestore();
        let batch = db.batch();

        let c1 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS)
        batch.set(c1,{[categoryId]:{[constants.WORKOUTS]:{[subcategoryId]:firebase.firestore.FieldValue.delete()}}},{merge:true});
        let c2 = db.collection(collections.WORKOUTS).doc(categoryId)
        batch.set(c2,{[constants.WORKOUTS]:{[subcategoryId]:firebase.firestore.FieldValue.delete()}},{merge:true})
        await batch.commit()
        return alert("Subcategory Deleted Successfully")
    }catch(error){
        return alert(error)
    }
}
export const deleteWorkoutPlan = async()=>{

    try{
        let categoryId = "5g2xYWXfTiQ6xMiTW6TX"

        //############################
        let db = firebase.firestore();
        let batch = db.batch();
        let c1 = db.collection(collections.K5METADATA).doc(documents.WORKOUTS);
        batch.set(c1,{[categoryId]:firebase.firestore.FieldValue.delete()},{merge:true})
        let c2 = db.collection(collections.WORKOUTS).doc(categoryId)
        batch.delete(c2)
        await batch.commit();
        return alert("Workout Plan Deleted Successfully")
   }catch(error){
       return alert(error)
   }
}

//ProductImageGallery
export const uploadProductImages = async()=>{

    try{
        let images = [];
        let categoryId = "";
        let subcategoryId="";
        //##############
        Promise.all(
            // Array of "Promises"
            images.map(item => uploadImage(item))
          )
          .then((url) => {
            console.log(`All success`)
          })
          .catch((error) => {
            console.log(`Some failed: `, error.message)
          });

    }catch(error){
        return alert(error)
    }
} 
 
//Carousel
export const fetchCarousel = async()=>{
    try{

        let db = firebase.firestore();
        let data = (await db.collection(collections.K5METADATA).doc(documents.CAROUSEL).get()).data();
        let carousel = [];
        for(let id in data){
            carousel.push(data[id])
        }
        console.log(carousel)
    }catch(error){
        return alert(error)
    }
}
export const uploadCarousel = async()=>{
    try{

        let image = {};
        let redirectUrl = "http://localhost:3000/category/weight-loss/belly-fat/pt1/VpEIkZNRjzSuefFu6ke8/pKzRUUaBZ46cHIklYYBk";
        let imgTitle= "Lose your weight now";
        //###########
        let path = `carousel/${generateUniqueId(6)}image.name`
        let url =  await uploadImage(path,image);
        let id = generateUniqueId(6)
        let carouselObj = {id:id,imgUrl:url,redirectUrl:redirectUrl,imgTitle:imgTitle}
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.CAROUSEL)
        .set({[id]:carouselObj},{merge:true})
        return alert("Carousel Added Successfully")
    }catch(error){
        return alert(error)
    }
}

export const deleteCarousel = async()=>{
    try{

        let carouselObj ={
            id: "gjjh",
            imgUrl: "https://images.squarespace-cdn.com/content/v1/59f0e161edaed84e6822a957/1571628555108-DY51TDBAHIVET3UUTMUG/ke17ZwdGBToddI8pDm48kGDIyjzonpL-SIH_-rfC9dEUqsxRUqqbr1mOJYKfIPR7LoDQ9mXPOjoJoqy81S2I8N_N4V1vUb5AoIIIbLZhVYxCRW4BPu10St3TBAUQYVKcZ8YuFwU-vI3pzKyV0SD7SwNRGg-RLS7V_9PYgJlWdsL2jExSAJ05vHpoYK-Qi6s6/Fitness-banner-1.jpg",
            imgTitle: "Slider Image title",
            redirectUrl:"https://localhost:3000/category/protein/workoutsupport/"
        }
        //########
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.CAROUSEL).set({[carouselObj.id]:firebase.firestore.FieldValue.delete()},{merge:true})
        await storage.refFromURL(carouselObj.imgUrl).delete();
        return alert("Carousel Deleted Successfully")
    }catch(error){
        return alert(error)
    }
}
//Ad Banner 
export const fetchAdBanner = async()=>{
    try{

        let db = firebase.firestore();
        let data = (await db.collection(collections.K5METADATA).doc(documents.BANNER).get()).data();
        let banner = [];
        for(let id in data){
            banner.push(data[id])
        }
        console.log(banner)
    }catch(error){
        return alert(error)
    }
}
export const createAdBanner = async()=>{
    try{

        let image = {};
        let redirectUrl = "http://localhost:3000/category/weight-loss/belly-fat/pt1/VpEIkZNRjzSuefFu6ke8/pKzRUUaBZ46cHIklYYBk";
        let imgTitle= "Lose your weight now";
        //###########
        let path = `banner/${generateUniqueId(6)}image.name`
        let url =  await uploadImage(path,image);
        let id = generateUniqueId(6)
        let carouselObj = {id:id,imgUrl:url,redirectUrl:redirectUrl,imgTitle:imgTitle}
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.BANNER)
        .set({[id]:carouselObj},{merge:true})
        return alert("Banner Added Successfully")
    }catch(error){
        return alert(error)
    }
}
export const deleteAdBanner = async()=>{
    try{

        try{

            let bannerObj ={
                id: "gjjh",
                imgUrl: "https://images.squarespace-cdn.com/content/v1/59f0e161edaed84e6822a957/1571628555108-DY51TDBAHIVET3UUTMUG/ke17ZwdGBToddI8pDm48kGDIyjzonpL-SIH_-rfC9dEUqsxRUqqbr1mOJYKfIPR7LoDQ9mXPOjoJoqy81S2I8N_N4V1vUb5AoIIIbLZhVYxCRW4BPu10St3TBAUQYVKcZ8YuFwU-vI3pzKyV0SD7SwNRGg-RLS7V_9PYgJlWdsL2jExSAJ05vHpoYK-Qi6s6/Fitness-banner-1.jpg",
                imgTitle: "Slider Image title",
                redirectUrl:"https://localhost:3000/category/protein/workoutsupport/"
            }
            //########
            let db = firebase.firestore();
            await db.collection(collections.K5METADATA).doc(documents.BANNER).set({[bannerObj.id]:firebase.firestore.FieldValue.delete()},{merge:true})
            await storage.refFromURL(bannerObj.imgUrl).delete();
            return alert("Banner Deleted Successfully")
        }catch(error){
            return alert(error)
        }

    }catch(error){
        return alert(error)
    }
}

//Clients
export const fetchClients = async()=>{
    try{

        let db = firebase.firestore();
        let data = (await db.collection(collections.K5METADATA).doc(documents.CLIENTS).get()).data();
        let clients = [];
        for(let id in data){
            clients.push(data[id])
        }
        console.log(clients)
    }catch(error){
        return alert(error)
    }
}
export const createClient = async()=>{
    try{

        let image = {};
        let redirectUrl = "http://localhost:3000/category/weight-loss/belly-fat/pt1/VpEIkZNRjzSuefFu6ke8/pKzRUUaBZ46cHIklYYBk";
        let imgTitle= "Lose your weight now";
        //###########
        let path = `clients/${generateUniqueId(12)}image.name`
        let url =  await uploadImage(path,image);
        let id = generateUniqueId(6)
        let carouselObj = {id:id,imgUrl:url,redirectUrl:redirectUrl,imgTitle:imgTitle}
        let db = firebase.firestore();
        await db.collection(collections.K5METADATA).doc(documents.CLIENTS)
        .set({[id]:carouselObj},{merge:true})
        return alert("Client Added Successfully")
    }catch(error){
        return alert(error)
    }
}
export const deleteClient= async()=>{
    try{

        try{

            let clientObj ={
                id: "gjjh",
                imgUrl: "https://images.squarespace-cdn.com/content/v1/59f0e161edaed84e6822a957/1571628555108-DY51TDBAHIVET3UUTMUG/ke17ZwdGBToddI8pDm48kGDIyjzonpL-SIH_-rfC9dEUqsxRUqqbr1mOJYKfIPR7LoDQ9mXPOjoJoqy81S2I8N_N4V1vUb5AoIIIbLZhVYxCRW4BPu10St3TBAUQYVKcZ8YuFwU-vI3pzKyV0SD7SwNRGg-RLS7V_9PYgJlWdsL2jExSAJ05vHpoYK-Qi6s6/Fitness-banner-1.jpg",
                imgTitle: "Slider Image title",
                redirectUrl:"https://localhost:3000/category/protein/workoutsupport/"
            }
            //########
            let db = firebase.firestore();
            await db.collection(collections.K5METADATA).doc(documents.CLIENTS).set({[clientObj.id]:firebase.firestore.FieldValue.delete()},{merge:true})
            await storage.refFromURL(clientObj.imgUrl).delete();
            return alert("Client Deleted Successfully")
        }catch(error){
            return alert(error)
        }

    }catch(error){
        return alert(error)
    }
}

//String Similarity check
function editDistance(s1, s2) {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = new Array();
    for (var i = 0; i <= s1.length; i++) {
      var lastValue = i;
      for (var j = 0; j <= s2.length; j++) {
        if (i == 0)
          costs[j] = j;
        else {
          if (j > 0) {
            var newValue = costs[j - 1];
            if (s1.charAt(i - 1) != s2.charAt(j - 1))
              newValue = Math.min(Math.min(newValue, lastValue),
                costs[j]) + 1;
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
      }
      if (i > 0)
        costs[s2.length] = lastValue;
    }
    return costs[s2.length];
  }
export const similarity = (s1, s2)=> {
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
      longer = s2;
      shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength == 0) {
      return 1.0;
    }
    return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
  }

  //SearchApi

  const createSearchSpace = (keyword)=>{
    keyword = keyword.toLowerCase().trim();
    let searchSpace = [];
    let temp = "";
    for(let i=0;i<keyword.length;i++){
        temp+=keyword.charAt(i);
        searchSpace.push(temp)
    }
    let words = keyword.split(" ");
    return [...searchSpace,...(words.splice(1,words.length))]
  }

  export const shouldInsertSearchKey = async(productTitle)=>{
      try{
         
        // let productTitle = "Optimum Nutrition Whey Protein";
        let searchKeys = ["Whey Protein","Sporto Fitness Gym Gloves"] 
         //#############
         let flag = false;
         for(let i=0;i<searchKeys.length;i++){
             let similar =  similarity(productTitle,searchKeys[i])
             if(similar>0.5){
                 flag =false
                 break;
             }
             if(i==searchKeys.length-1){
                flag = true
             }
         }

         if(flag){
             return true
         }else{
             return false
         }
         

      }catch(error){

        return alert(error)
      }
  }
  
//Product


const DELHIVERY_TOKEN="7aace25b78d0c025dbedac429ef90c78c5d8159d"
const DElHIVERY_TEST_URL="https://staging-express.delhivery.com";
const DELHIVERY_PRODUCTION_URL="https://track.delhivery.com"
const cors = "https://cors-anywhere.herokuapp.com/"
const DELHIVERY_TEST_CLIENT = "K5FITNESSSURFACE-B2C";
const DELHIVERY_CLIENT="K5FITNESS SURFACE"
const DELHIVERY_PRODUCTION_TOKEN="cefe4e09e990c77e79368a2404be9492a2141eb6"



  //Delhivery Api

  export const checkServiceAvailability = async()=>{
   
    "https://staging-express.delhivery.com/c/api/pin-codes/json/?token=7aace25b78d0c025dbedac429ef90c78c5d8159d&filter_codes=400033"
    
    try{
        let pincode = 456010;
        let payment_mode="cod";
    // let payment_mode="pre_paid";
        //############
        let url = cors+DElHIVERY_TEST_URL+"/c/api/pin-codes/json/?token="+DELHIVERY_TOKEN+"&filter_codes="+pincode
        let result = (await axios.get(url)).data
        
        //1)
        console.log(result)
        if(!result.delivery_codes.length){
            return console.log("Sorry Can't deliver at this pincode")
        }
        let postal_code = result.delivery_codes[0].postal_code;
        if(postal_code[payment_mode]!=="Y"){
            return console.log(`Sorry ${payment_mode} is not available at this pincode`)
        }
        return console.log("Service Available")
    }catch(error){
        return console.log(error)
    }


  } 

  export const fetchWayBill = async()=>{
    try{
        
        let url = cors+DElHIVERY_TEST_URL+"/waybill/api/fetch/json/?cl="+DELHIVERY_TEST_CLIENT
        let result  = (await axios.get(url)).data;
        let waybill = result;
        console.log(waybill)
    }catch(error){
        return console.log(error)
    }
  }

//   export const createForwardOrder = async()=>{
//       try{

//         let url = cors+DElHIVERY_TEST_URL+"/api/cmu/create.json";
//         let result = await axios.post(url,{})

//       }catch(error){
//           return console.log(error)
//       }
//   }

export const getShippingInvoice = async()=>{
    try{
        let config =  { 'authorization':`Token ${DELHIVERY_PRODUCTION_TOKEN}`,'accept': "application/json",'content-type': "application/json" }
        let url = cors+DELHIVERY_PRODUCTION_URL+"/api/kinko/v1/invoice/charges/.json/";
        console.log(url)
        let querystring = {"md":"S","cgm":"10","o_pin":"250004","ss":"Delivered","d_pin":"250001"}
        let result = await axios.get(url,{
            params:querystring,
            headers:config
        })
        console.log(result)

    }catch(error){
        return alert(error)
    }
}

 